import React from 'react';
import classNames from 'classnames/bind';
import { CompareButton, DeviceControlWrapper, FavoriteButton } from "../DeviceControl";
import { Description } from "./components/Description";
import { Header } from "./components/Header";
import { ContentWrapper } from "./components/ContentWrapper";
import { PicturesSection } from "./components/PicturesSection";
import style from "./styles.module.pcss";
export { BundleImage } from "./components/BundleSwitcher";
export { PromoItem } from "./components/Description";
var cn = classNames.bind(style);
export var DevicePreview = function DevicePreview(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'preview' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xl' : _ref$size,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$directionSlider = _ref.directionSlider,
    directionSlider = _ref$directionSlider === void 0 ? 'horizontal' : _ref$directionSlider,
    device = _ref.data,
    purchaseData = _ref.purchaseData,
    subscribeData = _ref.subscribeData,
    onChangeColor = _ref.onChangeColor,
    onChangeType = _ref.onChangeType,
    isFavoriteSelected = _ref.isFavoriteSelected,
    setFavorite = _ref.setFavorite;
  return /*#__PURE__*/React.createElement(ContentWrapper, {
    isLoading: isLoading,
    size: size
  }, !!device && /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', "wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('cols')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('stretch')
  }, /*#__PURE__*/React.createElement(Header, {
    device: device,
    type: type
  }))), /*#__PURE__*/React.createElement("div", {
    className: cn('content', "content--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('stretch')
  }, /*#__PURE__*/React.createElement(PicturesSection, {
    control: /*#__PURE__*/React.createElement(DeviceControlWrapper, {
      className: cn('device-control', {
        tablet: size === 'm',
        desktop: size === 'l' || size === 'xl'
      })
    }, /*#__PURE__*/React.createElement(FavoriteButton, {
      isSelected: isFavoriteSelected,
      isVisible: true,
      setIsSelected: setFavorite
    }), /*#__PURE__*/React.createElement(CompareButton, {
      isSelected: device === null || device === void 0 ? void 0 : device.isInCmp,
      isVisible: true,
      setIsSelected: device === null || device === void 0 ? void 0 : device.onCmpClick
    })),
    directionSlider: directionSlider,
    imgOptions: device === null || device === void 0 ? void 0 : device.imgOptions,
    isProductDetails: device === null || device === void 0 ? void 0 : device.isProductDetails,
    size: size
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('side', "side--".concat(size))
  }, /*#__PURE__*/React.createElement(Description, {
    device: device,
    onChangeColor: onChangeColor,
    onChangeType: onChangeType,
    purchaseData: purchaseData,
    size: size,
    subscribeData: subscribeData,
    type: type
  })))));
};